export default {
  key: "creditNoteGenerate",
  serviceKey: "hrdc",
  name: {
    singular: "Credit Note Generate",
    plural: "Credit Note Generate",
  },
  parents: [
    //
  ],
  add: {
    name: "Credit Note Generate",
  },
  view: {
    name: "Credit Note Generate",
  },
};
